/**
 * 判断资源是否为档案类型
 */
export function isArchiveResource(resource = {}) {
  const resourceType = String(resource.resourceType || '').trim()
  const resourceTypeLabel = String(resource.resourceTypeLabel || '').trim()
  const category = String(resource.resourceCategory || resource.categoryLabel || '').trim()

  const labels = [resourceTypeLabel, resourceType, category]
  if (labels.some((value) => value === '档案')) {
    return true
  }

  const attributes = []
    .concat(resource.attributes || [])
    .concat(resource.metaAttributes || [])
  return attributes.some((attr) => {
    const label = String((attr && attr.label) || '').trim()
    const value = String((attr && attr.value) || '').trim()
    return (label === '资源类别' || label === '类别') && value === '档案'
  })
}

export const ARCHIVE_PDF_LOGIN_REQUIRED_MESSAGE = '请先登录后再预览档案类文档'
export const ARCHIVE_PDF_BLOCKED_MESSAGE = '您的账号权限不足，无法预览档案类 PDF 文件'

/**
 * 档案类 PDF 预览拦截结果
 * - needLogin: 未登录
 * - noPermission: 已登录但 role=1（受限，不可查看档案）
 * - null: 允许预览
 */
export function getArchivePdfPreviewBlockReason(userInfo, isLoggedIn, resource = {}) {
  if (!isArchiveResource(resource)) {
    return null
  }
  if (!isLoggedIn || !userInfo) {
    return 'needLogin'
  }
  if (Number(userInfo.role) === 1) {
    return 'noPermission'
  }
  return null
}

/**
 * 档案类 PDF 是否不可预览（未登录或权限不足）
 */
export function isArchivePdfPreviewBlocked(userInfo, isLoggedIn, resource = {}) {
  return getArchivePdfPreviewBlockReason(userInfo, isLoggedIn, resource) != null
}

export function getArchivePdfPreviewBlockMessage(reason) {
  if (reason === 'needLogin') {
    return ARCHIVE_PDF_LOGIN_REQUIRED_MESSAGE
  }
  if (reason === 'noPermission') {
    return ARCHIVE_PDF_BLOCKED_MESSAGE
  }
  return ARCHIVE_PDF_BLOCKED_MESSAGE
}
